import { IMAGES } from "../../lib/brand";

const MOMENTS = [
  {
    key: "night-out",
    title: "Night Out",
    image: IMAGES.edits.night,
    alt: "Woman in a mauve polka-dot backless gown with matching head scarf, leaving a city venue at night",
  },
  {
    key: "euro-summer",
    title: "Euro Summer",
    image: IMAGES.edits.euro,
    alt: "Woman in a wide-brim straw hat and woven cream-and-tan dress on a yacht in a Mediterranean harbour",
  },
  {
    key: "wedding-season",
    title: "Wedding Season",
    image: IMAGES.edits.wedding,
    alt: "Woman in a tiered powder-blue satin gown beside a wooden door, soft afternoon light",
  },
];

export const CuratedMoments = () => {
  return (
    <section
      id="moments"
      data-testid="moments-section"
      className="relative w-full bg-[#F6F2EC] pt-12 md:pt-16 pb-28 md:pb-44"
    >
      <div className="mx-auto max-w-[1480px] px-6 md:px-10 lg:px-14">
        {/* Heading — restrained */}
        <div className="max-w-3xl mb-14 md:mb-20">
          <h2
            data-testid="moments-heading"
            className="font-editorial text-[#2B2320] text-5xl md:text-6xl lg:text-7xl leading-[1]"
          >
            Curated <span className="font-editorial-italic">moments.</span>
          </h2>
        </div>

        {/* 3-card editorial grid — large imagery, minimal centered text */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 lg:gap-x-12 gap-y-20">
          {MOMENTS.map((m) => (
            <article
              key={m.key}
              data-testid={`moment-card-${m.key}`}
              className="group"
            >
              <div className="aspect-[3/4] w-full overflow-hidden bg-[#ECE6DE]">
                <img
                  src={m.image}
                  alt={m.alt}
                  className="w-full h-full object-cover image-hover"
                />
              </div>
              <h3 className="mt-5 font-editorial text-[#2B2320] text-lg md:text-xl text-center tracking-wide">
                {m.title}
              </h3>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
